import { Component } from "@angular/core"
import { AlertController, NavParams, NavController, ViewController, LoadingController } from "ionic-angular"

import { EventService } from "../../services/event"

@Component({
  selector: "events-list-page",
  templateUrl: "list.html"
})
export class EventsListPage {

  events: any = []
  title = ""
  action = ""

  constructor(
    private alertCtrl: AlertController,
    private navParams: NavParams,
    private navCtrl: NavController,
    private viewCtrl: ViewController,
    private loadingCtrl: LoadingController
  ) {

    this.events = this.navParams.get("events")
    this.action = this.navParams.get("action")

    if (this.action == "confirm") {
      this.title = "Confirmação de Eventos"
    } else if (this.action == "exchange") {
      this.title = "Solicitações de Troca"
    } else if (this.action == "release") {
      this.title = "Eventos Liberados"
    }
  }

  ionViewWillEnter() {

    this.viewCtrl.setBackButtonText("Voltar")
  }

  onConfirmAll() {

    const loading = this.loadingCtrl.create({ content: "Por favor, aguarde..." })

    loading.present()

    loading.onDidDismiss(() => this.onStatusChanged())

    Promise.all(this.events.map((event) => {

      return EventService.confirmEvent(event)
        .then((event) => {

          event.hide = true

          return event
        })
    }))
    .then((events) => {

      this.events = events

      loading.dismiss()
    })
    .catch((error) => {

      console.log(error)

      loading.dismiss()

      this.alertCtrl.create({
        message: "Falha ao confirmar um ou mais eventos",
        buttons: ["Ok"]
      }).present()
    })
  }

  onStatusChanged() {

    let hasEventsVisible = false

    this.events.forEach((event) => {
      if (!event.hide)
        hasEventsVisible = true
    })

    if (!hasEventsVisible)
      this.navCtrl.pop()
  }
}



// WEBPACK FOOTER //
// ./src/pages/events/list.ts